var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),(_vm.path != '/Home' && _vm.path != '/og/finish')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }